import { useMutation, useQueryClient } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { updateCompanyOnboarding } from '../query-api'

export const useUpdateCompanyOnboarding = () => {
  const queryClient = useQueryClient()

  const {
    mutateAsync: update,
    isLoading: isProcessing,
    ...rest
  } = useMutation(updateCompanyOnboarding, {
    onSuccess: (response) => {
      queryClient.setQueryData(QueryKeys.CompanyOnboarding, response)
    },
  })

  return { isProcessing, update, ...rest }
}
